import Vue from "vue";
export default Vue.extend({
    metaInfo: function () {
        return {
            title: this.$t("Enquiry submitted").toString(),
        };
    },
});
